<template>
  <template v-if="!editorMode">
    <div :class="classMap" v-if="!multiple || (multiple && !draggable)" :style="$attrs.style">
      <a-tooltip overlayClassName="tooltip-box" placement="top" :title="tips">
        <div
          class="upload-item"
          :style="{ width: boxWidth, height: boxHeight }"
          v-if="!multiple && url !== ''"
          @mouseover="showImagePreView = true"
          @mouseleave="showImagePreView = false"
        >
          <a-popover placement="right" v-if="size === 'mini'" :open="showImagePreView">
            <template #content>
              <img :src="url" style="width: 400px" />
            </template>
            <img :src="url" class="upload-item__img" @click="imagePreview" />
          </a-popover>
          <img v-else :src="url" class="upload-item__img" @click="imagePreview" />
          <div v-if="!disabled && size !== 'mini'" class="image-edit-btn" @click="editImage()">替换</div>
          <div v-if="!disabled && size === 'mini'" class="image-mini-edit-btn" @click="editImage()">
            <ehf-icon class="btn-icon" icon="edit-2-fill"></ehf-icon>
          </div>
          <ehf-icon v-if="!disabled" icon="close-circle-fill" class="image-remove-btn" @click="removeImage()"></ehf-icon>
        </div>
      </a-tooltip>
      <template v-if="multiple && urlList.length !== 0">
        <a-tooltip overlayClassName="tooltip-box" placement="top" :title="tips">
          <div
            class="upload-item"
            :style="{ width: boxWidth, height: boxHeight }"
            v-for="(img, index) in urlList"
            :key="index"
            @mouseover="showImagePreView = true"
            @mouseleave="showImagePreView = false"
          >
            <a-popover placement="right" v-if="size === 'mini'" :open="showImagePreView">
              <template #content>
                <img :src="img" style="width: 300px" />
              </template>
              <img :src="img" class="upload-item__img" @click="imagePreview" />
            </a-popover>
            <img :src="img" class="upload-item__img" @click="imagePreview" />
            <div v-if="!disabled && size !== 'mini'" class="image-edit-btn" @click="editImage(index)">替换</div>
            <div v-if="!disabled && size === 'mini'" class="image-mini-edit-btn" @click="editImage()">
              <ehf-icon class="btn-icon" icon="edit-2-fill"></ehf-icon>
            </div>
            <ehf-icon v-if="!disabled" icon="close-circle-fill" class="image-remove-btn" @click="removeImage(index)"></ehf-icon>
            <div v-if="setMain" class="set-main-btn" @click.stop="setMainImg(img)">设为主图</div>
          </div>
        </a-tooltip>
      </template>
      <a-tooltip overlayClassName="tooltip-box" placement="top" :title="tips">
        <div
          class="upload-item add"
          :style="{ width: boxWidth, height: boxHeight }"
          v-show="(!multiple && url === '') || (multiple && urlList.length < max)"
          @click="addImage"
        >
          <ehf-icon icon="add-fill" class="upload-add-icon"></ehf-icon>
        </div>
      </a-tooltip>
    </div>

    <template v-else>
      <vuedraggable :class="classMap" v-model="urlList" item-key="index" @update="onChange()">
        <template #item="{ element, index }">
          <a-tooltip overlayClassName="tooltip-box" placement="top" :title="tips">
            <div
              class="upload-item draggable"
              :style="{ width: boxWidth, height: boxHeight }"
              @mouseover="showImagePreView = true"
              @mouseleave="showImagePreView = false"
            >
              <a-popover placement="right" v-if="size === 'mini'" :open="showImagePreView">
                <template #content>
                  <img :src="element" style="width: 300px" />
                </template>
                <img :src="element" class="upload-item__img" @click="imagePreview" />
              </a-popover>
              <img v-else :src="element" class="upload-item__img" @click="imagePreview" />
              <div v-if="!disabled && size !== 'mini'" class="image-edit-btn" @click="editImage(index)">替换</div>
              <ehf-icon v-if="!disabled" icon="close-circle-fill" class="image-remove-btn" @click="removeImage(index)"></ehf-icon>
              <div v-if="setMain" class="set-main-btn" @click.stop="setMainImg(element)">设为主图</div>
            </div>
          </a-tooltip>
        </template>
        <template #footer v-if="urlList.length < max">
          <a-tooltip overlayClassName="tooltip-box" placement="top" :title="tips">
            <div class="upload-item add" :style="{ width: boxWidth, height: boxHeight }" @click="addImage">
              <ehf-icon icon="add-fill" class="upload-add-icon"></ehf-icon>
            </div>
          </a-tooltip>
        </template>
      </vuedraggable>
    </template>
  </template>

  <a-modal
    v-if="ifModal"
    v-model:open="modalShow"
    centered
    :bodyStyle="bodyStyle"
    destroyOnClose
    width="1000px"
    :closable="false"
    :footer="false"
    :getContainer="getContainer"
    @cancel="closeModal"
  >
    <a-tabs type="card" v-model:activeKey="activeKey">
      <a-tab-pane key="select" tab="选择图片" v-if="!miniMode">
        <select-image
          :multiple="multiple || editorMode"
          :edit="editIndex !== -1"
          :max="maxNum"
          :limit="limit === '' ? null : limitObj"
          :groupId="groupId"
          @select="uploadSuccess"
          @cancel="closeModal"
          :maxWidth="maxWidth"
          :maxHeight="maxHeight"
          :limitSize="limitSize"
          :acceptFormat="acceptFormat"
          :needCache="needCache"
        />
      </a-tab-pane>
      <a-tab-pane key="upload" :tab="uploadTabName">
        <upload-image
          :multiple="multiple || editorMode"
          :edit="editIndex !== -1"
          :max="maxNum"
          :limit="limitObj"
          :miniMode="miniMode"
          :compressRate="compressRate"
          :forceCanvasCompress="forceCanvasCompress"
          :groupId="groupId"
          @upload="uploadSuccess"
          @cancel="closeModal"
          :maxWidth="maxWidth"
          :maxHeight="maxHeight"
          :limitSize="limitSize"
          :acceptFormat="acceptFormat"
          :qrName="qrName"
          :needCache="needCache"
        />
      </a-tab-pane>
      <template v-slot:rightExtra>
        <ehf-icon icon="close-fill" class="modal-close-btn" @click="closeModal"></ehf-icon>
      </template>
    </a-tabs>
  </a-modal>

  <ehf-image-preview ref="imagePreviewRef" />
</template>

<script>
  export default {
    name: 'EhfImageUpload',
  }
</script>

<script setup>
  import SelectImage from './components/SelectImage'
  import UploadImage from './components/UploadImage'
  import vuedraggable from 'vuedraggable'
  import { ref, watch, toRefs, computed } from 'vue'
  import { useGetters } from '../../utils/composables'
  import { useStore } from 'vuex'
  import { message } from 'ant-design-vue'

  const props = defineProps({
    modelValue: {
      type: [String, Array],
      default: '',
    },
    bodyStyle: {
      type: Object,
      default() {
        return { height: '600px', padding: '5px' }
      },
    },
    size: {
      type: String,
      default: 'default', // mini, small, default, large
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: 10,
    },
    /**
     * @description 文件大小限制，最大5mb，传入不带单位，默认单位kb，目前只接受kb，mb
     */
    limit: {
      type: String,
      default: '', // kb, mb
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    scale: {
      type: Object,
      default() {
        return {
          width: 100,
          height: 100,
        }
      },
    },
    defaultTab: {
      type: String,
      default: 'select',
    },
    miniMode: {
      type: Boolean,
      default: false,
    },
    compressRate: {
      type: Number,
      default: 0,
    },
    forceCanvasCompress: {
      type: Boolean,
      default: false,
    },
    editorMode: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    groupId: {
      type: String,
      default: '',
    },
    // 是否设置主图
    setMain: {
      type: Boolean,
      default: false,
    },
    getContainer: {
      type: Function,
      default: () => {
        return document.body
      },
    },
    limitSize: {
      type: Object,
      default() {
        return {
          width: null,
          height: null,
        }
      },
    },
    maxWidth: {
      type: Number,
      default: null,
    },
    maxHeight: {
      type: Number,
      default: null,
    },
    acceptFormat: {
      type: Array,
      default() {
        return ['jpg', 'png', 'gif']
      },
    },
    uploadTabName: {
      type: String,
      default() {
        return '上传图片'
      },
    },
    // 针对企业微信二维码 要上传名字 需求[ID1006395]
    qrName: {
      type: String,
      default() {
        return ''
      },
    },
    // 是否需要缓存
    needCache: {
      type: Boolean,
      default: false,
    },
    tips: {
      type: String,
      default: '',
    },
  })
  const { modelValue, visible } = toRefs(props)
  const emit = defineEmits(['update:visible', 'update:modelValue', 'change', 'select'])
  const { imageUpload: imageUploadCache } = useGetters('components', ['imageUpload']) // 缓存的上传组件数据

  const ifModal = ref(props.editorMode) // 是否渲染弹窗组件
  const modalShow = ref(props.editorMode ? props.visible : false) // 是否显示弹窗
  const url = ref(props.modelValue) // 绑定的数据，单张图片字符串
  const urlList = ref(props.editorMode ? [] : props.modelValue) // 绑定的数据，多张图片数组
  const editIndex = ref(-1) // 多图时编辑的图片下标
  const showImagePreView = ref(false) // 是否显示弹出层预览图片
  const multiple = computed(() => Array.isArray(modelValue.value)) // 是否多张图片
  const maxNum = computed(() => {
    if (multiple.value) {
      if (editIndex.value !== -1) {
        return 1
      } else {
        return props.max - urlList.value.length
      }
    } else {
      return 10
    }
  }) // 还可选择或上传的图片数量
  const limitObj = computed(() => {
    const limit_str = props.limit.toLocaleLowerCase()
    const reg = /^\d*(kb|mb)?$/
    if (props.limit === '' || !reg.test(limit_str)) {
      return {
        text: '2MB',
        size: 2 * 1024 * 1024,
      }
    } else {
      let limit_num = parseFloat(limit_str)
      if (limit_str.indexOf('kb') > -1) {
        // 默认单位kb
        if (limit_num > 5 * 1024) {
          return {
            text: '5MB',
            size: 2 * 1024 * 1024,
          }
        } else {
          return {
            text: limit_num + 'KB',
            size: limit_num * 1024,
          }
        }
      } else {
        if (limit_num > 5) {
          return {
            text: '5MB',
            size: 5 * 1024 * 1024,
          }
        } else {
          return {
            text: limit_num + 'MB',
            size: limit_num * 1024 * 1024,
          }
        }
      }
    }
  })
  // 图片大小限制相关数据
  const classMap = computed(() => ['upload-wrapper', props.size, { disabled: props.disabled }, { multiple: multiple.value }]) // class处理

  watch(modalShow, (val) => {
    if (props.editorMode) {
      emit('update:visible', val)
    }
    if (props.needCache) {
      if (val) {
        if (imageUploadCache.value && imageUploadCache.value.activeKey) {
          activeKey.value = imageUploadCache.value.activeKey
        }
      } else {
        setImageUploadCache({ activeKey: activeKey.value })
      }
    } else {
      clearCache('IMAGE_UPLOAD')
    }
  })
  watch(modelValue, (value) => {
    if (multiple.value) {
      urlList.value = value
    } else {
      url.value = value
    }
  })
  watch(visible, (value) => {
    if (value) {
      urlList.value = []
    }
    modalShow.value = value
  })

  // 展示框大小尺寸 --start
  let zoom = 1
  switch (props.size) {
    case 'mini':
      zoom = 0.4
      break
    case 'small':
      zoom = 0.8
      break
    case 'large':
      zoom = 1.2
      break
  }
  let scale_zoom = props.scale.width / props.scale.height
  let boxStyle = {
    width: scale_zoom > 1 ? 100 * scale_zoom * zoom : 100 * zoom,
    height: scale_zoom < 1 ? 100 * (1 / scale_zoom) * zoom : 100 * zoom,
  }
  const boxWidth = boxStyle.width + 'px'
  const boxHeight = boxStyle.height + 'px'
  // 展示框大小尺寸 --end

  const activeKey = ref(props.miniMode ? 'upload' : props.defaultTab) // 激活的tab页

  const store = useStore()
  const setImageUploadCache = (options) => store.dispatch('components/setImageUploadCache', options) // 设置组件部分数据缓存
  const clearCache = (key) => store.dispatch('components/clearCache', key) // 清除缓存
  // 添加图片
  const addImage = () => {
    if (props.disabled) {
      return
    }
    editIndex.value = -1
    ifModal.value = true
    modalShow.value = true
  }
  // 编辑图片
  const editImage = (index) => {
    if (props.disabled) {
      return
    }
    if (index !== undefined) {
      editIndex.value = index
    } else {
      editIndex.value = -1
    }
    ifModal.value = true
    modalShow.value = true
  }
  // 移除图片
  const removeImage = (index) => {
    if (props.disabled) {
      return
    }
    if (index || index === 0) {
      urlList.value.splice(index, 1)
    } else {
      url.value = ''
    }
    onChange()
  }
  // 选中图片确定变化时调用
  const onChange = (extra = {}) => {
    if (multiple.value || props.editorMode) {
      emit('update:modelValue', urlList.value)
      emit('change', urlList.value, extra)
    } else {
      emit('update:modelValue', url.value)
      emit('change', url.value, extra)
    }
  }
  // 上传成功回调
  const uploadSuccess = (urls, extra = {}) => {
    showImagePreView.value = false
    if (urls.length === 0) {
      return message.error('未上传或选择图片')
    }
    if (multiple.value || props.editorMode) {
      if (editIndex.value !== -1) {
        urlList.value.splice(editIndex.value, 1, urls[0])
      } else {
        urlList.value = urlList.value.concat(urls)
      }
    } else {
      url.value = urls[0]
    }
    onChange(extra)
    modalShow.value = false
  }
  // 设置主图
  const setMainImg = (url) => {
    emit('select', { type: 'main', url })
  }
  // 关闭弹窗
  const closeModal = () => {
    modalShow.value = false
    if (!props.editorMode) {
      setTimeout(() => {
        ifModal.value = false
      }, 460)
    }
  }
  // 图片放大预览
  const imagePreviewRef = ref(null)
  const imagePreview = (e) => {
    imagePreviewRef.value.initPhotoSwipeFromDOM('.upload-item .upload-item__img', e.target, true)
  }
  defineExpose({
    addImage,
  })
</script>

<style lang="scss" scoped>
  .upload-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 -5px;
    .upload-item {
      /*width: 100px;*/
      /*height: 100px;*/
      margin: 0 5px;
      border: 1px none #cccccc;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .upload-item__img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .image-edit-btn {
        display: none;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 25px;
        line-height: 25px;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.5);
      }
      .image-mini-edit-btn {
        display: none;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.3);
        cursor: pointer;
        .btn-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #ffffff;
          font-size: 16px;
        }
      }
      .image-remove-btn {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        transform: translate(50%, -50%);
        font-size: 20px;
        line-height: initial;
        &:after {
          content: '';
          position: absolute;
          width: 15px;
          height: 15px;
          left: 3px;
          top: 3px;
          background-color: #fff;
          border-radius: 50%;
          z-index: -1;
        }
      }
      .set-main-btn {
        position: absolute;
        top: 0;
        left: 0;
        background-color: $ehf-color-blue;
        color: #ffffff;
        font-size: 12px;
        line-height: initial;
        padding: 5px;
        cursor: pointer;
        display: none;
      }
      &:hover {
        .image-edit-btn {
          display: block;
        }
        .image-mini-edit-btn {
          display: block;
        }
        .image-remove-btn {
          display: block;
        }
        .set-main-btn {
          display: block;
        }
      }
    }
    .upload-item.add {
      cursor: pointer;
      border-style: dashed;
    }
    .upload-item.draggable {
      cursor: move;
    }
  }
  .upload-wrapper.multiple {
    .upload-item {
      margin-bottom: 10px;
    }
  }
  .upload-wrapper.disabled {
    .upload-item {
      &:hover {
        .image-edit-btn {
          display: none;
        }
        .image-remove-btn {
          display: none;
        }
      }
    }
    .upload-item.add {
      background-color: #eeeeee;
      cursor: not-allowed;
    }
  }
  .modal-close-btn {
    font-size: 20px;
    margin-right: 10px;
    cursor: pointer;
  }
  .ant-tabs-card {
    height: 100%;
  }
  ::v-deep(.ant-tabs-content) {
    height: 100%;
  }
</style>
